'use client'
import * as React from 'react'
import { shopLabsPackagesRoute } from '../../../../../common/constants/routes'
import { EagerLoadingSpinner } from '../../../../../common/components/EagerLoadingSpinner'
import styled from '@emotion/styled'
import { useRouter } from 'next/navigation'
import { visibleScreenHeightVar } from '../../../../../styles/visibleScreenHeightVarName'

const Container = styled.div`
  width: fill-available;
  height: ${visibleScreenHeightVar};
  display: flex;
  justify-content: center;
  align-items: center;
`

export function ShopLabsPage() {
  const { replace } = useRouter()
  React.useEffect(() => {
    replace(shopLabsPackagesRoute)
  }, [replace])

  return (
    <Container>
      <EagerLoadingSpinner />
    </Container>
  )
}
